import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { CONTROLLERS: { EXPENSES: { BASE } } } = USER;
const { METHOD: { GET } } = HOOKS_SETTINGS;

export const useDownloadExpenseReport = ({ customerId, externalId, fileType }: {customerId: string, externalId: string, fileType: string }) => useQuery(
  [fileType, customerId, externalId],
  async () => {
    if (!customerId || !externalId || !fileType) {
      return '';
    }
    try {
      const { data } = await httpService({
        url: `${BASE_URL}/api/v1/user/${customerId}/${BASE}/${externalId}/?outputType=${fileType}&forceRefresh=true`,
        method: GET,
        responseType: 'blob',
      });
      return URL.createObjectURL(data);
    } catch (e) {
      if (!process.env.TESTING) console.error(e);
      return '';
    }
  },
  {
    refetchOnWindowFocus: false,
  },
);
